export default __webpack_public_path__ + "static/media/pp2.0b4da2e6.png";